export enum Languages {
  en = 'en',
  da = 'da'
}
